import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_SI.json';
import recipes from './COOKING_RECIPES_SI.json';
import videos from './COOKING_VIDEOS_SI.json';

export const COOKING_DATA_SI: ServiceData = {
  articles,
  recipes,
  videos,
};
